/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Col_ToInputs */

const en_pwf_col_to = /** @type {(inputs: Pwf_Col_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New status`)
};

const de_pwf_col_to = /** @type {(inputs: Pwf_Col_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Status`)
};

/**
* | output |
* | --- |
* | "New status" |
*
* @param {Pwf_Col_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_col_to = /** @type {((inputs?: Pwf_Col_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Col_ToInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_col_to(inputs)
	return en_pwf_col_to(inputs)
});